import { Component, OnInit } from '@angular/core';
import { AuthorizeService } from '../../auth/authorize.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-login-menu',
  templateUrl: './login-menu.component.html',
  styleUrls: ['./login-menu.component.css']
})
export class LoginMenuComponent implements OnInit {
  public name!: Observable<string>;

  constructor(
    private authorizeService: AuthorizeService,
  ) { }

  ngOnInit() {
    this.name = this.authorizeService.getUser().pipe(map(u => u && u.name));
  }

  signOut() {
    this.authorizeService.signOut();
  }
}
